<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <template v-slot:activator="{ on }">
      <!-- <v-btn class="success" v-on="on"> -->
      <v-icon left v-on="on" small title="View" color="success">
        visibility
      </v-icon>
      <!-- </v-btn> -->
    </template>
    <v-card>
      <v-card-title>
        <v-icon left>person</v-icon>
        <span class="headline">User Details</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon large color="error">close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container grid-list-md class="py-0">
        <v-card-text class="py-0">
          <v-form>
            <v-text-field
              :value="newUser.name"
              label="Name"
              readonly
            ></v-text-field>
            <v-text-field
              :value="newUser.email"
              label="Email"
              readonly
            ></v-text-field>
            <v-text-field
              :value="newUser.role.name"
              label="User Type"
              readonly
            ></v-text-field>
            <label
              aria-hidden="true"
              class="v-label v-label--active theme--light"
              style="position: absolute; font-size: 12px"
            >
              User Status
            </label>
            <v-switch
              v-model="newUser.active"
              color="green"
              :label="newUser.active ? 'Active' : 'Inactive'"
              readonly
            ></v-switch>
          </v-form>
        </v-card-text>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: ["userDetails"],
    data() {
      return {
        dialog: false,
        newUser: null,
      };
    },

    created() {
      this.initialize();
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
    },
    methods: {
      async initialize() {
        this.newUser = { ...this.userDetails };
      },
      close() {
        this.dialog = false;
      },
      // goToEdit() {
      //   this.$emit("goToEdit");
      //   this.dialog = false;
      // },
    },
  };
</script>
